import PropTypes from 'prop-types';

import { ModalDialog } from '@febos-io/common';
import { Button } from '@febos-io/design';

export function ModalNewPatient(
  {
    closeModal,
    payload: {
      PatientForm
    }
  }
) {
  return (
    <ModalDialog
      useBackdropClose
      useCloseModal
      size="lg"
      title="Crear nuevo paciente"
    >
      <div className="row mt-3">
        <PatientForm />
      </div>
      <div className="row justify-content-end pe-4 pt-4">
        <div className="col-1">
          <Button className="bg-white text-primary" onClick={closeModal}>Cerrar</Button>
        </div>
        <div className="col-1 ms-3">
          <Button onClick={closeModal}>Crear</Button>
        </div>
      </div>
    </ModalDialog>
  );
}

export default ModalNewPatient;

ModalNewPatient.propTypes = {
  closeModal: PropTypes.func.isRequired,
  payload: PropTypes.shape({
    property1: PropTypes.string,
    property2: PropTypes.string,
    PatientForm: PropTypes.element
  })
};
